import { render, staticRenderFns } from "./WriteReceiverInfo.vue?vue&type=template&id=384085b5&scoped=true"
import script from "./WriteReceiverInfo.vue?vue&type=script&lang=js"
export * from "./WriteReceiverInfo.vue?vue&type=script&lang=js"
import style0 from "./WriteReceiverInfo.vue?vue&type=style&index=0&id=384085b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384085b5",
  null
  
)

export default component.exports